import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-modal';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import hostlink from '../Hostlink/hostlink';
import Loading from './Loading';

import 'react-toastify/dist/ReactToastify.css';
import './Reservation.css';

const Navbar = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [isFormDisabled, setIsFormDisabled] = useState(false);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    const [messagedata, setMessagedata] = useState({
        deleteid: "",
        deletemsg: ""
    });

    const navbarRef = useRef(null);
    const contentRef = useRef(null);

    const { deleteid, deletemsg } = messagedata;

    // =========================================================
    // USER
    // =========================================================

    const getUser = () => {
        try {
            const data = localStorage.getItem('MYPCKARTUSER');

            if (!data) return null;

            const parsed = JSON.parse(data);

            if (Array.isArray(parsed) && parsed.length > 0) {
                return parsed[0];
            }

            return null;

        } catch (error) {
            console.error("User Parse Error:", error);
            return null;
        }
    };

    const user = getUser();

    const companyName = user?.cname || "MyPckart";
    const userEmail = user?.email || "";
    const userName = user?.name || user?.username || userEmail || "Administrator";

    // =========================================================
    // FULL SCREEN
    // =========================================================

    const toggleFullScreen = () => {

        if (!document.fullscreenElement) {

            document.documentElement
                .requestFullscreen()
                .then(() => {
                    setIsFullScreen(true);
                })
                .catch(err => {
                    console.error(
                        `Error attempting to enable full-screen mode: ${err.message}`
                    );
                });

        } else {

            if (document.exitFullscreen) {

                document.exitFullscreen();

                setIsFullScreen(false);
            }
        }
    };

    // =========================================================
    // SUBMIT
    // =========================================================

    const handleSubmit = (event) => {
        event.preventDefault();
    };

    // =========================================================
    // MODAL
    // =========================================================

    const handleOpenModal = (e, flname) => {

        setMessagedata({
            ...messagedata,
            deleteid: e || "",
            deletemsg: flname || ""
        });

        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleNoClick = () => {

        handleCloseModal();

        window.location.assign("/");
    };

    // =========================================================
    // LOGIN
    // =========================================================

    const checkuser = async () => {

        const usernameInput =
            document.getElementById("exampleDropdownFormEmail1");

        const passwordInput =
            document.getElementById("exampleDropdownFormPassword1");

        const inputValue =
            usernameInput?.value.trim() || "";

        const inputValue2 =
            passwordInput?.value.trim() || "";

        if (inputValue === "") {

            toast.error("Please Enter UserName...");

            usernameInput?.focus();

            return false;
        }

        if (inputValue2 === "") {

            toast.error("Please Enter Password...");

            passwordInput?.focus();

            return false;
        }

        try {

            setIsLoading(true);

            // -------------------------------------------------
            // CHECK USERNAME
            // -------------------------------------------------

            const nameQuery =
                `select * from shopmas where email = '${inputValue}' limit 1`;

            const nameResponse = await axios.get(
                `${hostlink}/api/executeQuery?sqlQuery=${encodeURIComponent(nameQuery)}`
            );

            if (
                !Array.isArray(nameResponse.data) ||
                nameResponse.data.length === 0
            ) {

                toast.error("Invalid Username...");

                setIsLoading(false);

                usernameInput?.focus();

                return false;
            }

            // -------------------------------------------------
            // CHECK PASSWORD
            // -------------------------------------------------

            const nameQueryPassword =
                `select * from shopmas where password = '${inputValue2}' limit 1`;

            const nameQueryPasswordResp = await axios.get(
                `${hostlink}/api/executeQuery?sqlQuery=${encodeURIComponent(nameQueryPassword)}`
            );

            if (
                !Array.isArray(nameQueryPasswordResp.data) ||
                nameQueryPasswordResp.data.length === 0
            ) {

                toast.error("Enter Valid Password...");

                setIsLoading(false);

                passwordInput?.focus();

                return false;
            }

            // -------------------------------------------------
            // LOGIN
            // -------------------------------------------------

            const response = await axios.get(
                `${hostlink}/shopmas/${encodeURIComponent(inputValue)}/${encodeURIComponent(inputValue2)}`
            );

            const responseData = response.data;

            localStorage.removeItem('MYPCKARTUSER');

            localStorage.setItem(
                'MYPCKARTUSER',
                JSON.stringify(responseData)
            );

            if (
                Array.isArray(responseData) &&
                responseData.length === 0
            ) {

                toast.error(
                    "Enter Valid username and password.."
                );

                setIsLoading(false);

                usernameInput?.focus();

                return false;
            }

            toast.success("Login Successful");

            setTimeout(() => {
                window.location.assign("/");
            }, 800);

        } catch (error) {

            console.error("Login Error:", error);

            toast.error("Unable to login. Please try again.");

            setIsLoading(false);
        }
    };

    // =========================================================
    // LOGOUT
    // =========================================================

    const logoutdevice = () => {

        localStorage.removeItem('MYPCKARTUSER');

        window.location.assign("/");
    };

    // =========================================================
    // NAVBAR HEIGHT
    // =========================================================

    useEffect(() => {

        const adjustPadding = () => {

            if (
                navbarRef.current &&
                contentRef.current
            ) {

                const navbarHeight =
                    navbarRef.current.offsetHeight;

                contentRef.current.style.paddingTop =
                    `${navbarHeight}px`;
            }
        };

        adjustPadding();

        window.addEventListener(
            'resize',
            adjustPadding
        );

        return () => {

            window.removeEventListener(
                'resize',
                adjustPadding
            );
        };

    }, []);

    // =========================================================
    // LOGIN STATUS
    // =========================================================

    useEffect(() => {

        const myPckartUser =
            localStorage.getItem('MYPCKARTUSER');

        try {

            if (
                myPckartUser &&
                JSON.parse(myPckartUser).length === 0
            ) {

                localStorage.removeItem(
                    'MYPCKARTUSER'
                );
            }

        } catch (error) {

            localStorage.removeItem(
                'MYPCKARTUSER'
            );
        }

        setIsLoggedIn(!!myPckartUser);

        const pathname =
            window.location.pathname;

        const parts =
            pathname.split('/');

        const pageName =
            parts[parts.length - 1];

        if (
            pageName !== "Company_Create" &&
            pageName !== "RecoveryyPassword"
        ) {

            if (!myPckartUser) {

                handleOpenModal(
                    "1",
                    "1"
                );
            }
        }

    }, []);

    // =========================================================
    // NAV ITEM
    // =========================================================

    const NavItem = ({
        href,
        icon,
        children
    }) => {

        return (
            <li className="nav-item">

                <a
                    href={href}
                    className="modern-nav-link"
                >

                    <span className="nav-icon">
                        <i className={`fa-solid ${icon}`}></i>
                    </span>

                    <span>
                        {children}
                    </span>

                </a>

            </li>
        );
    };

    // =========================================================
    // DROPDOWN ITEM
    // =========================================================

    const DropdownItem = ({
        href,
        icon,
        children
    }) => {

        return (
            <li>

                <a
                    className="modern-dropdown-item"
                    href={href}
                >

                    <span className="dropdown-icon">
                        <i className={`fa-solid ${icon}`}></i>
                    </span>

                    <span>
                        {children}
                    </span>

                    <i className="fa-solid fa-chevron-right dropdown-arrow"></i>

                </a>

            </li>
        );
    };

    // =========================================================
    // RENDER
    // =========================================================

    return (

        <div
            ref={contentRef}
            className="modern-navbar-wrapper"
        >

            {/* =====================================================
                SAME FILE CSS
            ====================================================== */}

            <style>{`

                .modern-navbar {
                    background:
                        linear-gradient(
                            135deg,
                            #0f172a 0%,
                            #172554 48%,
                            #1d4ed8 100%
                        );

                    min-height: 66px;

                    border-bottom:
                        1px solid rgba(255,255,255,0.10);

                    box-shadow:
                        0 8px 30px rgba(15,23,42,0.20);

                    backdrop-filter:
                        blur(14px);
                }


                .modern-brand {
                    display: flex;
                    align-items: center;
                    gap: 11px;

                    text-decoration: none;

                    color: #ffffff !important;

                    font-weight: 800;

                    font-size: 17px;

                    white-space: nowrap;
                }


                .brand-logo {
                    width: 40px;
                    height: 40px;

                    display: flex;
                    align-items: center;
                    justify-content: center;

                    border-radius: 12px;

                    background:
                        rgba(255,255,255,0.14);

                    border:
                        1px solid rgba(255,255,255,0.16);

                    box-shadow:
                        inset 0 1px 0 rgba(255,255,255,0.15);

                    font-size: 17px;
                }


                .brand-text {
                    display: flex;
                    flex-direction: column;

                    line-height: 1.05;
                }


                .brand-title {
                    font-size: 15px;
                    font-weight: 800;
                    letter-spacing: 0.2px;
                }


                .brand-subtitle {
                    font-size: 9px;

                    font-weight: 500;

                    opacity: 0.60;

                    margin-top: 4px;

                    letter-spacing: 0.7px;

                    text-transform: uppercase;
                }


                .modern-navbar .navbar-nav {
                    gap: 3px;
                }


                .modern-nav-link {
                    display: flex;

                    align-items: center;

                    gap: 7px;

                    padding:
                        9px 10px;

                    border-radius: 10px;

                    color:
                        rgba(255,255,255,0.80) !important;

                    text-decoration: none;

                    font-size: 12px;

                    font-weight: 600;

                    transition:
                        all 0.20s ease;
                }


                .modern-nav-link:hover {
                    color: #ffffff !important;

                    background:
                        rgba(255,255,255,0.12);

                    transform:
                        translateY(-1px);
                }


                .nav-icon {
                    width: 24px;
                    height: 24px;

                    display: flex;

                    align-items: center;

                    justify-content: center;

                    border-radius: 7px;

                    background:
                        rgba(255,255,255,0.08);

                    font-size: 11px;
                }


                .modern-dropdown {
                    border: 0;

                    padding: 8px;

                    min-width: 235px;

                    border-radius: 14px;

                    background:
                        rgba(255,255,255,0.98);

                    box-shadow:
                        0 18px 45px rgba(15,23,42,0.22);

                    animation:
                        dropdownIn 0.16s ease;
                }


                @keyframes dropdownIn {

                    from {
                        opacity: 0;
                        transform: translateY(-6px);
                    }

                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }

                }


                .modern-dropdown-item {
                    display: flex;

                    align-items: center;

                    gap: 10px;

                    padding:
                        9px 10px;

                    margin: 2px 0;

                    border-radius: 9px;

                    color: #334155 !important;

                    text-decoration: none;

                    font-size: 12px;

                    font-weight: 600;

                    transition:
                        all 0.18s ease;
                }


                .modern-dropdown-item:hover {
                    background: #eff6ff;

                    color: #1d4ed8 !important;

                    padding-left: 13px;
                }


                .dropdown-icon {
                    width: 30px;
                    height: 30px;

                    display: flex;

                    align-items: center;
                    justify-content: center;

                    border-radius: 8px;

                    background: #f1f5f9;

                    color: #475569;

                    font-size: 11px;
                }


                .modern-dropdown-item:hover
                .dropdown-icon {
                    background: #dbeafe;
                    color: #2563eb;
                }


                .dropdown-arrow {
                    margin-left: auto;

                    font-size: 8px;

                    opacity: 0;

                    transition:
                        opacity 0.15s ease;
                }


                .modern-dropdown-item:hover
                .dropdown-arrow {
                    opacity: 0.7;
                }


                .user-pill {
                    display: flex;

                    align-items: center;

                    gap: 9px;

                    padding:
                        5px 9px 5px 6px;

                    border-radius: 12px;

                    background:
                        rgba(255,255,255,0.10);

                    border:
                        1px solid rgba(255,255,255,0.12);

                    text-decoration: none;

                    color: white !important;

                    transition:
                        all 0.20s ease;
                }


                .user-pill:hover {
                    background:
                        rgba(255,255,255,0.17);

                    color: white !important;
                }


                .user-avatar {
                    width: 34px;
                    height: 34px;

                    border-radius: 10px;

                    display: flex;

                    align-items: center;

                    justify-content: center;

                    background:
                        linear-gradient(
                            135deg,
                            #60a5fa,
                            #2563eb
                        );

                    color: white;

                    font-size: 12px;

                    box-shadow:
                        0 4px 12px rgba(37,99,235,0.30);
                }


                .user-info {
                    display: flex;
                    flex-direction: column;

                    line-height: 1.1;

                    max-width: 130px;
                }


                .user-company {
                    font-size: 11px;

                    font-weight: 700;

                    white-space: nowrap;

                    overflow: hidden;

                    text-overflow: ellipsis;
                }


                .user-label {
                    font-size: 9px;

                    opacity: 0.60;

                    margin-top: 3px;
                }


                .user-chevron {
                    font-size: 9px;

                    opacity: 0.65;

                    margin-left: 3px;
                }


                .navbar-toggler-modern {
                    border:
                        1px solid rgba(255,255,255,0.18);

                    border-radius: 10px;

                    padding: 7px 9px;
                }


                .navbar-toggler-modern:focus {
                    box-shadow:
                        0 0 0 3px rgba(96,165,250,0.25);
                }


                .mobile-menu {
                    background:
                        rgba(15,23,42,0.98);

                    border-top:
                        1px solid rgba(255,255,255,0.08);

                    padding: 12px;
                }


                .mobile-menu .modern-nav-link {
                    margin-bottom: 3px;
                }


                .login-modal {
                    width: min(430px, 92vw);

                    border-radius: 22px;

                    overflow: hidden;

                    background: #ffffff;

                    box-shadow:
                        0 30px 80px rgba(15,23,42,0.30);
                }


                .login-header {
                    padding: 28px 28px 24px;

                    background:
                        linear-gradient(
                            135deg,
                            #0f172a,
                            #1d4ed8
                        );

                    color: white;
                }


                .login-logo {
                    width: 52px;
                    height: 52px;

                    display: flex;

                    align-items: center;

                    justify-content: center;

                    border-radius: 15px;

                    background:
                        rgba(255,255,255,0.14);

                    margin-bottom: 15px;

                    font-size: 22px;
                }


                .login-title {
                    font-size: 22px;

                    font-weight: 800;

                    margin: 0;
                }


                .login-subtitle {
                    font-size: 11px;

                    opacity: 0.70;

                    margin-top: 5px;
                }


                .login-body {
                    padding: 24px 28px 28px;
                }


                .modern-label {
                    font-size: 11px;

                    font-weight: 700;

                    color: #475569;

                    margin-bottom: 6px;
                }


                .modern-input {
                    border-radius: 11px !important;

                    border:
                        1px solid #e2e8f0 !important;

                    padding:
                        10px 12px !important;

                    font-size: 13px !important;

                    transition:
                        all 0.18s ease;
                }


                .modern-input:focus {
                    border-color:
                        #3b82f6 !important;

                    box-shadow:
                        0 0 0 3px
                        rgba(59,130,246,0.12) !important;
                }


                .login-btn {
                    border: 0;

                    border-radius: 11px;

                    padding: 10px 20px;

                    font-size: 12px;

                    font-weight: 700;

                    background:
                        linear-gradient(
                            135deg,
                            #2563eb,
                            #1d4ed8
                        );

                    color: white;

                    box-shadow:
                        0 6px 16px
                        rgba(37,99,235,0.25);
                }


                .login-btn:hover {
                    color: white;

                    transform:
                        translateY(-1px);

                    box-shadow:
                        0 9px 20px
                        rgba(37,99,235,0.32);
                }


                .logout-card {
                    padding: 30px;

                    text-align: center;
                }


                .logout-icon {
                    width: 65px;
                    height: 65px;

                    margin: 0 auto 15px;

                    display: flex;

                    align-items: center;

                    justify-content: center;

                    border-radius: 18px;

                    background: #eff6ff;

                    color: #2563eb;

                    font-size: 25px;
                }


                @media (max-width: 991px) {

                    .modern-navbar {
                        min-height: 60px;
                    }

                    /* Mobile menu: allow the complete navbar to scroll */
                    .modern-navbar .navbar-collapse {
                        margin-top: 10px;
                        max-height: calc(100vh - 70px);
                        overflow-y: auto;
                        overflow-x: hidden;
                        padding-bottom: 12px;
                        -webkit-overflow-scrolling: touch;
                        scrollbar-width: thin;
                    }

                    .modern-navbar .navbar-collapse::-webkit-scrollbar {
                        width: 5px;
                    }

                    .modern-navbar .navbar-collapse::-webkit-scrollbar-track {
                        background: transparent;
                    }

                    .modern-navbar .navbar-collapse::-webkit-scrollbar-thumb {
                        background: rgba(148, 163, 184, 0.45);
                        border-radius: 10px;
                    }

                    .modern-navbar .navbar-nav {
                        gap: 2px;
                    }

                    .modern-nav-link {
                        padding: 10px 11px;
                    }

                    /* Every dropdown can scroll when there is not enough space */
                    .modern-dropdown {
                        box-shadow: none;
                        border-radius: 10px;
                        margin: 4px 0 7px;
                        background: #f8fafc;
                        max-height: 62vh;
                        overflow-y: auto;
                        overflow-x: hidden;
                        -webkit-overflow-scrolling: touch;
                        scrollbar-width: thin;
                    }

                    .modern-dropdown::-webkit-scrollbar {
                        width: 5px;
                    }

                    .modern-dropdown::-webkit-scrollbar-track {
                        background: transparent;
                    }

                    .modern-dropdown::-webkit-scrollbar-thumb {
                        background: rgba(148, 163, 184, 0.45);
                        border-radius: 10px;
                    }

                    .modern-dropdown-item {
                        min-height: 44px;
                    }

                    .user-pill {
                        margin-top: 8px;
                        width: 100%;
                        justify-content: flex-start;
                    }

                }


                @media (max-width: 575px) {

                    .modern-navbar .navbar-collapse {
                        max-height: calc(100vh - 64px);
                    }

                    .modern-navbar .modern-dropdown {
                        max-height: 55vh;
                    }

                    .modern-navbar .report-dropdown {
                        max-height: 60vh;
                    }

                    .brand-subtitle {
                        display: none;
                    }

                    .brand-title {
                        font-size: 14px;
                    }

                    .brand-logo {
                        width: 36px;
                        height: 36px;
                    }

                    .login-body {
                        padding: 20px;
                    }

                    .login-header {
                        padding: 24px 20px 20px;
                    }

                }

            `}</style>


            {/* =====================================================
                NAVBAR
            ====================================================== */}

            <nav
                ref={navbarRef}
                className="navbar navbar-expand-lg fixed-top modern-navbar"
            >

                <div className="container-fluid px-3 px-lg-4">

                    {/* BRAND */}

                    <a
                        href="/"
                        className="modern-brand"
                    >

                        <span className="brand-logo">

                            <i className="fa-solid fa-layer-group"></i>

                        </span>

                        {/* <span className="brand-text">

                            <span className="brand-title">
                                {companyName}
                            </span>

                            <span className="brand-subtitle">
                                Business Management
                            </span>

                        </span> */}

                    </a>


                    {/* MOBILE BUTTON */}

                    <button
                        className="navbar-toggler navbar-toggler-modern"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#modernNavbar"
                        aria-controls="modernNavbar"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >

                        <span
                            className="navbar-toggler-icon"
                            style={{
                                filter: "invert(1)"
                            }}
                        ></span>

                    </button>


                    {/* MENU */}

                    <div
                        className="collapse navbar-collapse"
                        id="modernNavbar"
                        style={{
                            display: isModalOpen ? "none" : undefined
                        }}
                    >

                        <ul className="navbar-nav me-auto mb-2 mb-lg-0 ms-lg-3">


                            {/* =================================================
                                MASTER
                            ================================================== */}

                            <li className="nav-item dropdown">

                                <a
                                    className="modern-nav-link dropdown-toggle"
                                    href="/"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >

                                    <span className="nav-icon">
                                        <i className="fa-solid fa-database"></i>
                                    </span>

                                    Master

                                </a>


                                <ul className="dropdown-menu modern-dropdown">

                                    <DropdownItem
                                        href="/AccountMaster"
                                        icon="fa-address-card"
                                    >
                                        Account
                                    </DropdownItem>

                                    <DropdownItem
                                        href="/FabMas"
                                        icon="fa-industry"
                                    >
                                        Fabricator
                                    </DropdownItem>

                                    <DropdownItem
                                        href="/WasherMas"
                                        icon="fa-cart-flatbed-suitcase"
                                    >
                                        Washer
                                    </DropdownItem>

                                    <DropdownItem
                                        href="/FinishingMas"
                                        icon="fa-check-to-slot"
                                    >
                                        Pressman
                                    </DropdownItem>

                                    <DropdownItem
                                        href="/FinshingEntryOpening"
                                        icon="fa-cubes"
                                    >
                                        Opening
                                    </DropdownItem>

                                    {/* <DropdownItem
                                        href="/EmployeeMaster"
                                        icon="fa-user-group"
                                    >
                                        Employee Master
                                    </DropdownItem> */}

                                    <DropdownItem
                                        href="/TailorMas"
                                        icon="fa-scissors"
                                    >
                                        Tailor Master
                                    </DropdownItem>

                                </ul>

                            </li>





                            {/* =================================================
                                MAIN LINKS
                            ================================================== */}

                            <NavItem
                                href="/Purchase"
                                icon="fa-book"
                            >
                                Purchase
                            </NavItem>





                            <NavItem
                                href="/Cutting"
                                icon="fa-scissors"
                            >
                                Cutting
                            </NavItem>


                            <NavItem
                                href="/FabricatorEntry"
                                icon="fa-industry"
                            >
                                Fabricator
                            </NavItem>

                           


                            <li className="nav-item dropdown">

                                <a
                                    className="modern-nav-link dropdown-toggle"
                                    href="#tailor"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >

                                    <span className="nav-icon">
                                        <i className="fa-solid fa-users-gear"></i>
                                    </span>

                                    Tailor

                                </a>


                                <ul className="dropdown-menu modern-dropdown">

                                    <DropdownItem
                                        href="/TailorReceive"
                                        icon="fa-user-tie"
                                    >
                                        Tailor Receive
                                    </DropdownItem>


                                    <DropdownItem
                                        href="/TailorReport"
                                        icon="fa-chart-column"
                                    >
                                        Tailor Report
                                    </DropdownItem>

                                </ul>

                            </li>











                            <NavItem
                                href="/WasherEntry"
                                icon="fa-recycle"
                            >
                                Washer
                            </NavItem>


                            <NavItem
                                href="/FinshingEntry"
                                icon="fa-check-to-slot"
                            >
                                Finishing
                            </NavItem>


                            <NavItem
                                href="/SaleEntry"
                                icon="fa-bag-shopping"
                            >
                                Sale
                            </NavItem>


                            <NavItem
                                href="/SaleEntryReturn"
                                icon="fa-rotate-right"
                            >
                                Return
                            </NavItem>

                            <li className="nav-item dropdown">

                                <a
                                    className="modern-nav-link dropdown-toggle"
                                    href="/"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >

                                    <span className="nav-icon">
                                        <i className="fa-solid fa-users-gear"></i>
                                    </span>

                                    HR

                                </a>


                                <ul className="dropdown-menu modern-dropdown">

                                    <DropdownItem
                                        href="/EmployeeMaster"
                                        icon="fa-user-tie"
                                    >
                                        Employee Master
                                    </DropdownItem>

                                    <DropdownItem
                                        href="/EmployeeAttendance"
                                        icon="fa-calendar-check"
                                    >
                                        Attendance
                                    </DropdownItem>

                                    <DropdownItem
                                        href="/EmployeeAttendanceReport"
                                        icon="fa-calendar-check"
                                    >
                                        Attendance Report
                                    </DropdownItem>



                                    <DropdownItem
                                        href="/EmployeeAdvance"
                                        icon="fa-hand-holding-dollar"
                                    >
                                        Employee Advance
                                    </DropdownItem>

                                    <DropdownItem
                                        href="/EmployeeSalary"
                                        icon="fa-calculator"
                                    >
                                        Salary Processing
                                    </DropdownItem>

                                    <DropdownItem
                                        href="/EmployeeSalaryPayment"
                                        icon="fa-money-bill-transfer"
                                    >
                                        Salary Payment
                                    </DropdownItem>

                                    <DropdownItem
                                        href="/EmployeeLedger"
                                        icon="fa-book-open"
                                    >
                                        Employee Ledger
                                    </DropdownItem>

                                </ul>

                            </li>


                            {/* =================================================
                                REPORT
                            ================================================== */}

                            <li className="nav-item dropdown">

                                <a
                                    className="modern-nav-link dropdown-toggle"
                                    href="/"
                                    role="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >

                                    <span className="nav-icon">
                                        <i className="fa-solid fa-chart-column"></i>
                                    </span>

                                    Report

                                </a>


                                <ul className="dropdown-menu modern-dropdown report-dropdown">

                                    <DropdownItem
                                        href="/FindLotDetail"
                                        icon="fa-circle-info"
                                    >
                                        Lot Details
                                    </DropdownItem>

                                    <DropdownItem
                                        href="/FindLot"
                                        icon="fa-magnifying-glass"
                                    >
                                        Pending Lot
                                    </DropdownItem>

                                    <DropdownItem
                                        href="/Rpt_PurchaseReport"
                                        icon="fa-book"
                                    >
                                        Purchase Report
                                    </DropdownItem>

                                    <DropdownItem
                                        href="/Rpt_PurchaseReport_GR"
                                        icon="fa-arrow-rotate-left"
                                    >
                                        GR Report
                                    </DropdownItem>

                                    <DropdownItem
                                        href="/Rpt_CuttingReport"
                                        icon="fa-scissors"
                                    >
                                        Cutting Report
                                    </DropdownItem>

                                    <DropdownItem
                                        href="/Rpt_FabricatorReport"
                                        icon="fa-industry"
                                    >
                                        Fabricator Report
                                    </DropdownItem>

                                    <DropdownItem
                                        href="/Rpt_FinishingReport"
                                        icon="fa-check-to-slot"
                                    >
                                        Pressman Report
                                    </DropdownItem>

                                    <DropdownItem
                                        href="/Rpt_WashReport"
                                        icon="fa-recycle"
                                    >
                                        Washing Report
                                    </DropdownItem>

                                    <DropdownItem
                                        href="/GodwnStk"
                                        icon="fa-warehouse"
                                    >
                                        Godown Stock Report
                                    </DropdownItem>

                                    <DropdownItem
                                        href="/Rpt_SaleReport"
                                        icon="fa-bag-shopping"
                                    >
                                        Sale Report
                                    </DropdownItem>

                                    <DropdownItem
                                        href="/Rpt_SaleReport_Return"
                                        icon="fa-rotate-right"
                                    >
                                        Sales Return Report
                                    </DropdownItem>

                                    <DropdownItem
                                        href="/Rpt_FinalStock"
                                        icon="fa-layer-group"
                                    >
                                        Final Stock Report
                                    </DropdownItem>

                                </ul>

                            </li>

                            <NavItem
                                href="/PurchaseGR"
                                icon="fa-arrow-rotate-left"
                            >
                                GR
                            </NavItem>




                        </ul>


                        {/* =====================================================
                            RIGHT SIDE
                        ====================================================== */}

                        <div className="d-flex align-items-center gap-2">


                            {/* FULL SCREEN */}

                            {/* <button
                                type="button"
                                onClick={toggleFullScreen}
                                className="btn border-0 text-white d-none d-xl-flex align-items-center justify-content-center"
                                title={
                                    isFullScreen
                                        ? "Exit Full Screen"
                                        : "Full Screen"
                                }
                                style={{
                                    width: "36px",
                                    height: "36px",
                                    borderRadius: "10px",
                                    background:
                                        "rgba(255,255,255,0.08)"
                                }}
                            >

                                <i
                                    className={
                                        isFullScreen
                                            ? "fa-solid fa-compress"
                                            : "fa-solid fa-expand"
                                    }
                                ></i>

                            </button> */}


                            {/* USER */}

                            <a
                                href="#"
                                className="user-pill"
                                onClick={(e) => {

                                    e.preventDefault();

                                    handleOpenModal();

                                }}
                            >

                                <span className="user-avatar">

                                    <i className="fa-solid fa-user"></i>

                                </span>


                                <span className="user-info">

                                    <span className="user-company">
                                        {companyName}
                                    </span>

                                    <span className="user-label">
                                        {isLoggedIn
                                            ? "Account"
                                            : "Login"
                                        }
                                    </span>

                                </span>


                                <i className="fa-solid fa-chevron-down user-chevron"></i>

                            </a>

                        </div>

                    </div>

                </div>

            </nav>


            {/* =====================================================
                LOGIN / LOGOUT MODAL
            ====================================================== */}

            <Modal
                isOpen={isModalOpen}
                onRequestClose={handleCloseModal}
                contentLabel={
                    isLoggedIn
                        ? "Account"
                        : "Login"
                }
                className="login-modal"
                overlayClassName="modal-overlay"
                ariaHideApp={false}
            >

                {isLoggedIn ? (

                    /* =================================================
                       LOGGED IN
                    ================================================== */

                    <div className="logout-card">

                        <div className="logout-icon">

                            <i className="fa-solid fa-circle-user"></i>

                        </div>


                        <h4
                            style={{
                                fontWeight: "800",
                                marginBottom: "5px"
                            }}
                        >
                            {companyName}
                        </h4>


                        <div
                            className="text-muted mb-4"
                            style={{
                                fontSize: "11px"
                            }}
                        >
                            Manage your account
                        </div>


                        <div className="d-flex flex-column gap-2">

                            <a
                                href="/Passwordchange"
                                className="btn btn-outline-primary btn-sm"
                                style={{
                                    borderRadius: "10px",
                                    fontWeight: "700",
                                    padding: "10px"
                                }}
                            >

                                <i className="fa-solid fa-key me-2"></i>

                                Change Password

                            </a>


                            <button
                                type="button"
                                onClick={logoutdevice}
                                className="btn btn-danger btn-sm"
                                style={{
                                    borderRadius: "10px",
                                    fontWeight: "700",
                                    padding: "10px"
                                }}
                            >

                                <i className="fa-solid fa-right-from-bracket me-2"></i>

                                Logout

                            </button>


                            <button
                                type="button"
                                onClick={handleCloseModal}
                                className="btn btn-light btn-sm"
                                style={{
                                    borderRadius: "10px",
                                    fontWeight: "600",
                                    padding: "9px"
                                }}
                            >
                                Cancel
                            </button>

                        </div>

                    </div>

                ) : (

                    /* =================================================
                       LOGIN
                    ================================================== */

                    <div>

                        {/* HEADER */}

                        <div className="login-header">

                            <div className="login-logo">

                                <i className="fa-solid fa-lock-open"></i>

                            </div>


                            <h3 className="login-title">
                                Welcome Back
                            </h3>


                            <div className="login-subtitle">
                                Sign in to access your business dashboard
                            </div>

                        </div>


                        {/* BODY */}

                        <div className="login-body">

                            <div className="mb-3">

                                <label
                                    htmlFor="exampleDropdownFormEmail1"
                                    className="modern-label"
                                >
                                    USERNAME
                                </label>

                                <div className="input-group">

                                    <span
                                        className="input-group-text"
                                        style={{
                                            borderRadius: "11px 0 0 11px",
                                            borderColor: "#e2e8f0",
                                            background: "#f8fafc"
                                        }}
                                    >
                                        <i className="fa-solid fa-user text-muted"></i>
                                    </span>

                                    <input
                                        type="email"
                                        className="form-control modern-input"
                                        id="exampleDropdownFormEmail1"
                                        placeholder="Enter username"
                                        style={{
                                            borderRadius:
                                                "0 11px 11px 0 !important"
                                        }}
                                    />

                                </div>

                            </div>


                            <div className="mb-3">

                                <label
                                    htmlFor="exampleDropdownFormPassword1"
                                    className="modern-label"
                                >
                                    PASSWORD
                                </label>

                                <div className="input-group">

                                    <span
                                        className="input-group-text"
                                        style={{
                                            borderRadius: "11px 0 0 11px",
                                            borderColor: "#e2e8f0",
                                            background: "#f8fafc"
                                        }}
                                    >
                                        <i className="fa-solid fa-key text-muted"></i>
                                    </span>

                                    <input
                                        type="password"
                                        className="form-control modern-input"
                                        id="exampleDropdownFormPassword1"
                                        placeholder="Enter password"
                                    />

                                </div>

                            </div>


                            <div className="d-flex justify-content-between align-items-center mb-4">

                                <div className="form-check">

                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="dropdownCheck"
                                    />

                                    <label
                                        className="form-check-label"
                                        htmlFor="dropdownCheck"
                                        style={{
                                            fontSize: "11px",
                                            color: "#64748b"
                                        }}
                                    >
                                        Remember me
                                    </label>

                                </div>


                                <a
                                    href="/RecoveryyPassword"
                                    style={{
                                        color: "#2563eb",
                                        fontSize: "11px",
                                        fontWeight: "600",
                                        textDecoration: "none"
                                    }}
                                >

                                    <i className="fa-solid fa-key me-1"></i>

                                    Forgot password?

                                </a>

                            </div>


                            <div className="d-flex gap-2">

                                <button
                                    type="button"
                                    onClick={checkuser}
                                    className="login-btn flex-grow-1"
                                >

                                    <i className="fa-solid fa-right-to-bracket me-2"></i>

                                    Login

                                </button>


                                <button
                                    type="button"
                                    onClick={handleNoClick}
                                    className="btn btn-light"
                                    style={{
                                        borderRadius: "11px",
                                        fontSize: "12px",
                                        fontWeight: "600",
                                        padding: "10px 16px"
                                    }}
                                >
                                    Cancel
                                </button>

                            </div>

                        </div>

                    </div>

                )}

            </Modal>


            {/* TOAST */}

            <ToastContainer
                position="top-right"
                autoClose={1200}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                pauseOnHover
                theme="light"
            />


            {/* LOADING */}

            {isLoading && <Loading />}

        </div>
    );
};

export default Navbar;